"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SeijukudoComment = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 成熟度コメント
 */
const HeaderLabel = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    paddingTop: theme.spacing(1)
  };
});
const SeijukudoComment = props => {
  const {
    intl,
    kansabumonComment
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeaderLabel, null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_KANSABUMON_COMMENT
    }),
    indent: true
  }, kansabumonComment && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, kansabumonComment.split('\n').map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
    key: index
  }, line, /*#__PURE__*/_react.default.createElement("br", null)))))));
};
exports.SeijukudoComment = SeijukudoComment;
var _default = exports.default = (0, _reactIntl.injectIntl)(SeijukudoComment);